import { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Template from './Template';
import TemplateListContainer from './template-list/TemplateListContainer';

export const TemplatesRouter: FC = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path}>
                <TemplateListContainer />
            </Route>
            <Route path={`${path}/:name`}>
                <Template />
            </Route>
        </Switch>
    );
};
